
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {QrcodeStream} from "vue-qrcode-reader";
import Timeout = NodeJS.Timeout;

const CAMERA_FAIL_CHECK_DURATION_MS: number = 10000;

@Component({
  components: {
    QrcodeStream,
  },
})
export default class VueQrcodeReader extends Vue {

  @Prop({default: false})
  public loading: boolean;

  private mountingReader: boolean = true;
  private camera: string = "auto";
  private cameraPermission: any = null;
  private cameraFailTimer: Timeout = null;
  private enablingCamera: boolean = false;

  @Watch("loading")
  public handlerLoading(newVal, oldVal) {
    // If we're not loading anymore, put the camera back on
    if (!newVal && oldVal) {
      this.enablingCamera = true;
      this.camera = "auto";
      // The camera takes some time to be enabled,
      // so we need to delay the loading for more smoothness
      setTimeout(() => {
        this.enablingCamera = false;
      }, 550);
    }
  }

  private async beforeMount() {
    // Get camera permission
    this.cameraPermission = await this.getCameraPermission();

    // Trigger camera fail check in any case
    // (we suppose the user will take less than 10 seconds to accept camera permission)
    this.setCameraFailTimer();

    // If camera permission is already granted, start timer to check camera failure
    // if (this.cameraPermission.state === "granted") {
    //   this.setCameraFailTimer();
    // } else {
    //   // Else, add listener to watch permission changes
    //   this.cameraPermission.onchange = () => {
    //     // tslint:disable-next-line
    //     console.log(`[cameraPermission.onchange] change : ${this.cameraPermission.state}`);
    //     if (this.cameraPermission.state === "granted") {
    //       this.setCameraFailTimer();
    //     }
    //   };
    // }
  }

  private async getCameraPermission(): Promise<any> {
    // tslint:disable-next-line
    console.log("[checkCameraPermission] function start");
   return navigator.permissions.query({
      name: "camera" as PermissionName,
    }).then((result) => {
      // tslint:disable-next-line
      console.log(`[checkCameraPermission] done : ${result.state}`);
      return result;
    }).catch((error) => {
      // tslint:disable-next-line
      console.error("[checkCameraPermission] error : ", error);
    });
  }

  // Start timer to check for camera loading failure
  private setCameraFailTimer() {
    // tslint:disable-next-line
    console.log("[setCameraFailTimer] function start");
    this.cameraFailTimer = setTimeout(() => {
      // If camera is not working after few seconds, handle error
      this.$emit("error", "FailedToLoadCamera");
    }, CAMERA_FAIL_CHECK_DURATION_MS);
  }

  // Check if component's stream has been set up correctly
  private async onInit(promise): Promise<void> {
    // tslint:disable-next-line
    console.log("[onInit] function start");
    this.mountingReader = true;
    return promise
      .then((res) => {
        // tslint:disable-next-line
        console.log('[onInit] done : ', res);
        // Camera is working
        clearTimeout(this.cameraFailTimer);
      })
      .catch((error) => {
        // tslint:disable-next-line
        console.error("[onInit] error : ", error);
        // Camera isn't working with specific error
        this.$emit("error", error.name);
        clearTimeout(this.cameraFailTimer);
      })
      .finally(() => {
        this.mountingReader = false;
      });
  }

  private onDecode(decodedString: string): void {
    if (decodedString) {
      this.camera = "off";
      this.$emit("decode", decodedString);
    }
  }
}
